import React, { useMemo, useCallback } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	brandId: string;
	onChange: ({ brandId, value }: { brandId: string; value: Nullable<number> }) => void;
}

export const BankFeeField: React.FC<IProps> = React.memo(({ brandId, onChange }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterBankFee') }], [t]);

	const handleChange = useCallback(
		(value: Nullable<number>) => {
			onChange({ brandId, value });
		},
		[onChange, brandId],
	);

	return (
		<FormInputNew
			testId="BankFee"
			name={`bankFee-${brandId}`}
			label="bankFeeLabel"
			type="number"
			min={0}
			max={100}
			precision={2}
			onChangeNumber={handleChange}
			validationRules={validationRules}
		/>
	);
});
